/* unplugin-vue-components disabled */import script from "./NotifyContent.vue?vue&type=script&setup=true&lang=js"
export * from "./NotifyContent.vue?vue&type=script&setup=true&lang=js"

import "./NotifyContent.vue?vue&type=style&index=0&id=2e6fcbe0&lang=scss"

const __exports__ = script;

export default __exports__